var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"category"},_vm._l((_vm.list),function(item,key){return _c('div',{key:key,class:{'isActive':_vm.current.categoryId == item.id},on:{"click":function($event){return _vm.changeCurrent(item.id)}}},[_vm._v("\n        "+_vm._s(item.name)+"\n    ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }